import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyByD9MuwVpqwNsNGCVd1aA-zh_folXi1Bs",
  authDomain: "clone-787cb.firebaseapp.com",
  databaseURL: "https://clone-787cb.firebaseio.com",
  projectId: "clone-787cb",
  storageBucket: "clone-787cb.appspot.com",
  messagingSenderId: "224257138633",
  appId: "1:224257138633:web:c068378bb9a3a4e8919218",
  measurementId: "G-0EQ07YGFV4",
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

//firestore - real-time db in firebase
const db = firebaseApp.firestore();
const auth = firebase.auth();

export { db, auth };
